import { computed, ref, h, reactive } from 'vue';
import useDisplay from './useDisplay';
import { useFilteringFacetsStore } from '#stores/filteringFacets';
import CriteriaWrapper from '#components/filtering-facets/criteria/CriteriaWrapper.vue';

const facetsOptions = ref([]);
const activeDropdown = ref(null);

export default function useFacetOptions() {
  const store = useFilteringFacetsStore();

  const buildFacetsList = () => {
    const facets = computed(() => store.facets);
    facetsOptions.value = facets.value.map((facet) => {
      const selectedValues = computed(() => {
        const facetData = store.getFacetByName(facet.name);
        return facetData?.selectedValues || [];
      });
      const number = computed(() => selectedValues.value.length || '');
      return {
        id: facet.name,
        contents: {
          text: computed(() => `${facet.name}`),
          number: computed(() => number.value),
        },
        outlined: computed(() => !!selectedValues.value.length),
        dropdown: {
          customComponent: h(CriteriaWrapper, { name: facet.name }),
        },
      };
    });
  };

  const updateFacetsFilter = (store) => {
    const { isMobile } = useDisplay();
    if (isMobile.value) {
      if (facetsOptions?.value?.[0]?.id !== 'filter') {
        const hasSingleFacet = facetsOptions.value.length === 1;
        facetsOptions.value.forEach((option) => {
          option.dropdownHide = option.dropdown;
          delete option.dropdown;
        });
        const number = computed(() => store.allSelectedCriteria.facets.map((facet) => facet.selectedValues).flat().length);
        const filterFacet = reactive({
          id: 'filter',
          contents: {
            icon: 'utility-filter',
            text: computed(() => 'Filter'),
            number: computed(() => number.value),
          },
          outlined: computed(() => !!number.value),
        });
        if (hasSingleFacet) {
          facetsOptions.value = [filterFacet];
        } else {
          facetsOptions.value = [filterFacet].concat(facetsOptions.value);
        }
      }
    } else if (facetsOptions.value?.[0]?.id === 'filter') {
      // Rebuild facets for desktop view
      buildFacetsList();
    }
  };

  return {
    facetsOptions,
    activeDropdown,
    buildFacetsList,
    updateFacetsFilter,
  };
}
